import styled from 'styled-components'

export const Header = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 12px;

	h3 {
		margin: 0;
	}
`
